<template>
	<div class="order-setting-body">
		<div class="fx-header">
			<p>单据设置</p>
		</div>
		<div class="order-setting-container">
			<el-collapse v-model="activeNames">
				<el-collapse-item title="付款" class="accept-order" name="9">
					<div class="paytype-box">
						<div class="paytype-item">
							<div class="span-box">付款方式设置：</div>
							<el-radio-group v-model="paymentMethodSetting" size="mini" :disabled="!AuthorityList['06_0001_0002_00']" @change="paymentMethodSettingChange">
								<el-radio :label="0">全局设置</el-radio>
								<el-radio :label="1">按店铺设置</el-radio>
							</el-radio-group>
						</div>
						<template v-if="paymentMethodSetting === 0">
							<div class="paytype-item">
								<div class="span-box">付款方式：</div>
								<el-select size="mini" :disabled="!AuthorityList['06_0001_0002_00']" v-model="paytype" class="select-box" @change="paytypeChange(paytype)">
									<el-option label="先付款后发货" value="0"></el-option>
									<el-option label="先发货后支付" value="1"></el-option>
								</el-select>
								<el-tooltip effect="dark" placement="top" popper-class="tip-class">
									<div slot="content">
										先付款后发货：买家对整单支付后，卖家才能进行拣货、发 货操作（不包括订单处理过程中生成的额外支付费用）。 <br/><br/>
										先发货后付款：提单时，买家使用信用额度支付，或者不支付，在订单处理过程中买家再支付。
									</div>
									<img src="@/assets/images/icon/tooltip-icon.png" class="tip-icon">
								</el-tooltip>
							</div>
							<div class="paytype-item">
								<div class="span-box">设置订单流程：</div>
								<span>（点击成选中状态即视为单据成开启状态，否则视为关闭状态）</span>
								<el-tooltip effect="dark" placement="top" popper-class="tip-class">
									<div slot="content">
										只可针对待接单、财务审核进行订单流程设置， 其余状态不可设置。
									</div>
									<img src="@/assets/images/icon/tooltip-icon.png" class="tip-icon">
								</el-tooltip>
							</div>
							<div class="paytype-item" style="margin-left: 90px;">
								<div v-for="item in items" :key="'g-' + item.name + '-' + item.id">
									<div>
										<div class="item-box" :class="[item.active ? 'active' : 'unactive', item.id === 1 && isRed ? 'red' : '']"  :style="item.id === 6 ? 'width:94px;' : 'width:82px;'" @click="orderStatusChange(item)">
											{{item.name}}
											<img src="@/assets/images/icon/active.png" style="display:inline-block;position: absolute;" v-if="item.active">
											<img src="@/assets/images/icon/unactive.png" style="display:inline-block;position: absolute;" v-else>
										</div>
										<img src="@/assets/images/icon/arrow.png" class="tip-icon" v-if="item.id !== 4">
									</div>
								</div>
							</div>
							<div class="paytype-item" v-if="paytype === '1'">
								<div class="span-box">可付款状态：</div>
								<el-checkbox-group v-model="checkedStatus">
									<el-checkbox v-for="item in status" :label="item.name" :key="item.name" :disabled="item.name === '已完成' || !AuthorityList['06_0001_0002_00']" @change="settingStatus(item)">{{item.name}}</el-checkbox>
								</el-checkbox-group>
							</div>
						</template>
						<template v-else>
							<div class="payment-branch-box">
								<div class="paytype-item payment-branch-head">
									<div class="span-box">先付款后发货：</div>
									<el-button type="primary" size="mini" :disabled="!AuthorityList['06_0001_0002_00']" @click="openShopPaymentDialog(false)">选择店铺</el-button>
								</div>
								<div class="paytype-item">
									<div class="span-box">设置订单流程：</div>
									<span>（点击成选中状态即视为单据成开启状态，否则视为关闭状态）</span>
									<el-tooltip effect="dark" placement="top" popper-class="tip-class">
										<div slot="content">
											只可针对待接单、财务审核进行订单流程设置， 其余状态不可设置。
										</div>
										<img src="@/assets/images/icon/tooltip-icon.png" class="tip-icon">
									</el-tooltip>
								</div>
								<div class="paytype-item" style="margin-left: 90px;">
									<div v-for="item in itemsBranch0" :key="'b0-' + item.name + '-' + item.id">
										<div>
											<div class="item-box" :class="[item.active ? 'active' : 'unactive', item.id === 1 && isRed ? 'red' : '']" :style="item.id === 6 ? 'width:94px;' : 'width:82px;'" @click="orderStatusChangeBranch(item, '0')">
												{{item.name}}
												<img src="@/assets/images/icon/active.png" style="display:inline-block;position: absolute;" v-if="item.active">
												<img src="@/assets/images/icon/unactive.png" style="display:inline-block;position: absolute;" v-else>
											</div>
											<img src="@/assets/images/icon/arrow.png" class="tip-icon" v-if="item.id !== 4">
										</div>
									</div>
								</div>
							</div>
							<div class="payment-branch-box payment-branch-box--second">
								<div class="paytype-item payment-branch-head">
									<div class="span-box">先发货后支付：</div>
									<el-button type="primary" size="mini" :disabled="!AuthorityList['06_0001_0002_00']" @click="openShopPaymentDialog(true)">选择店铺</el-button>
								</div>
								<div class="paytype-item">
									<div class="span-box">设置订单流程：</div>
									<span>（点击成选中状态即视为单据成开启状态，否则视为关闭状态）</span>
									<el-tooltip effect="dark" placement="top" popper-class="tip-class">
										<div slot="content">
											只可针对待接单、财务审核进行订单流程设置， 其余状态不可设置。
										</div>
										<img src="@/assets/images/icon/tooltip-icon.png" class="tip-icon">
									</el-tooltip>
								</div>
								<div class="paytype-item" style="margin-left: 90px;">
									<div v-for="item in itemsBranch1" :key="'b1-' + item.name + '-' + item.id">
										<div>
											<div class="item-box" :class="[item.active ? 'active' : 'unactive', item.id === 1 && isRed ? 'red' : '']" :style="item.id === 6 ? 'width:94px;' : 'width:82px;'" @click="orderStatusChangeBranch(item, '1')">
												{{item.name}}
												<img src="@/assets/images/icon/active.png" style="display:inline-block;position: absolute;" v-if="item.active">
												<img src="@/assets/images/icon/unactive.png" style="display:inline-block;position: absolute;" v-else>
											</div>
											<img src="@/assets/images/icon/arrow.png" class="tip-icon" v-if="item.id !== 4">
										</div>
									</div>
								</div>
								<div class="paytype-item">
									<div class="span-box">可付款状态：</div>
									<el-checkbox-group v-model="checkedStatusBranch1">
										<el-checkbox v-for="item in statusBranch1" :label="item.name" :key="'bs1-' + item.name" :disabled="item.name === '已完成' || !AuthorityList['06_0001_0002_00']" @change="settingStatusBranch">{{item.name}}</el-checkbox>
									</el-checkbox-group>
								</div>
							</div>
						</template>
					</div>
				</el-collapse-item>
				<el-dialog title="选择店铺" :visible.sync="shopPaymentDialogVisible" width="780px" append-to-body @closed="resetShopPaymentDialog">
					<div v-loading="shopPaymentSaveLoading">
						<bindShop
							v-if="shopPaymentDialogVisible"
							:customerDialog.sync="shopPaymentDialogVisible"
							:chooseData1="shopPaymentChooseShop"
							@reloadCus="onShopPaymentBindSave"
						/>
					</div>
				</el-dialog>
				<el-collapse-item title="待付款" class="accept-order" name="6" v-if="paytype === '0'">
					<div style="width:50%">
						<div class="span-box">是否启用付款前审核设置：</div>
						<el-select size="mini" :disabled="!AuthorityList['06_0001_0002_00']" v-model="needAuditingFlag" class="select-box" @change="needAuditingFlagChange">
							<el-option label="不启用" :value="false"></el-option>
							<el-option label="启用" :value="true"></el-option>
						</el-select>
						<div v-if="needAuditingFlag" style="color:red;margin-left:150px">买家下单后，订单状态变更为待接单状态，卖家接单后可继续付款！</div>
						<div v-else style="color:red;margin-left:150px">买家下单后可直接付款，不需要卖家接单后在付款</div>
					</div>
					<div style="width:50%;margin-top:20px">
						<div class="span-box">待付款订单失效时间设置：</div>
						<el-input :disabled="!AuthorityList['06_0001_0002_00']" v-model="invalidTime" @blur="changeTime" size='mini' class="input-box number" style="width: 170px;margin-right: 10px;"></el-input>
						<span>小时</span>
						<div style="color:red;margin-left:150px"><span v-if="!timeFlag">请输入0.1~720以内的数字,只支持1位小数！</span></div>
					</div>
				</el-collapse-item>
				<el-collapse-item title="待接单" class="accept-order" name="1">
					<div style="display:flex;margin-bottom:20px;">
						<div style="width:50%;">
							<div class="span-box">是否启用提醒：</div>
							<el-select size="mini" :disabled="!AuthorityList['06_0001_0002_00'] || form.difference==='0'" v-model="isVioce" class="select-box" @change="settingVioce(0)">
								<el-option v-for="item in optionList" :value="item.id" :label="item.name" :key="item.id"></el-option>
							</el-select>
						</div>
						<div style="width:50%" v-if="reconciliationShow">
							<div class="span-box">是否启用定时接单：</div>
							<el-select size="mini" :disabled="!AuthorityList['06_0001_0002_00'] || form.difference==='0'" v-model="timedreceiveorderflag" style="width:160px" @change="timedreceiveorderflagChange">
								<el-option label="不启用" :value="0"></el-option>
								<el-option label="启用" :value="1"></el-option>
							</el-select>
							<div style="display:inline-block;" v-if="timedreceiveorderflag === 1">
								<span style="margin-left:20px">订单创建时间+</span>
								<el-input :disabled="!AuthorityList['06_0001_0002_00']" v-model="timedreceiveordertime" @blur="dreceivetimeChange" size='mini' type='number' style="width: 165px;margin-right: 10px;"></el-input>
								<span>小时</span>
							</div>
							<div style="color:red;margin-left:360px"><span v-if="!dreceivetimeFlag">请输入0~720以内的数字！</span></div>
						</div>
					</div>
					<!-- <div style="width:50%">
						<div class="span-box">是否启用待接单设置：</div>
						<el-select size="mini" :disabled="!AuthorityList['06_0001_0002_00'] || needAuditingFlag" v-model="form.difference" class="select-box" @change="settingChange">
							<el-option label="不启用" value="0"></el-option>
							<el-option label="启用" value="1"></el-option>
						</el-select>
						<div style="color:red;margin-left:150px">{{ confirmContent }}</div>
					</div> -->
					<div style="display:flex">
						<div style="width:50%">
							<div class="span-box" style="width: 182px;">修改订单后是否允许立即接单：</div>
							<el-select size="mini" :disabled="!AuthorityList['06_0001_0002_00']" v-model="form.difference2" class="select-box" @change="canDirectSendSetting">
								<el-option label="不允许" value="0"></el-option>
								<el-option label="允许" value="1"></el-option>
							</el-select>
							<div v-if="form.difference2 === '0'" style="color:red;margin-left:150px">待接单详情页不展示按钮【立即接单】</div>
							<div v-else style="color:red;margin-left:150px">待接单详情页展示按钮【立即接单】</div>
						</div>
						<div style="width:50%;display: flex;">
							<div class="span-box hide-title">是否启用自动打印：<span class="hide-span" @click="goStaff">员工档案</span></div>
							<div>
								<el-select size="mini" v-model="autoprint" :disabled="!AuthorityList['06_0001_0002_00'] || form.difference === 0" class="select-box" @change="autoprintChange" style="margin-right:10px;">
									<el-option label="不启用" value="0"></el-option>
									<el-option label="启用" value="1"></el-option>
								</el-select>
								<el-select size="mini" v-model="printname" class="select-box" :disabled="!AuthorityList['06_0001_0002_00'] || form.difference === 0" style="width:170px" v-show="autoprint === '1'" @change="printnameChange">
									<el-option
										v-for="item in printerOptions"
										:key="item.value"
										:label="item.label"
										:value="item.value">
									</el-option>
								</el-select>
								<div v-show="autoprint === '1'">
									<span style="color:red;">员工档案开启自动打印后,该功能才可生效</span>
									<span style="color:red;margin-left:25px">选择打印机启动自动打印生效</span>
								</div>
							</div>
						</div>
					</div>
					<!-- <div>
						<div class="span-box" style="width: 182px;">是否开启财务审核：</div>
						<el-select size="mini" :disabled="!AuthorityList['06_0001_0002_00']" v-model="form.financialAuditFlag" class="select-box" @change="financialAuditSetting(form.financialAuditFlag)">
							<el-option label="不开启财务审核" value="0"></el-option>
							<el-option label="开启财务审核" value="1"></el-option>
						</el-select>
					</div> -->
				</el-collapse-item>
				<el-collapse-item title="财务审核" class="accept-order" name="3">
					<div style="display:flex">
						<div>
							<div class="span-box" style="width: 182px;">是否启用根据支付方式审核：</div>
							<el-select size="mini" :disabled="!AuthorityList['06_0001_0002_00'] || !(paytype === '0' && form.financialAuditFlag === '1')" v-model="payAuditFlag" class="select-box" @change="payAuditFlagSetting">
								<el-option label="不启用" value="0"></el-option>
								<el-option label="启用" value="1"></el-option>
							</el-select>
							<el-tooltip effect="dark" placement="top" popper-class="tip-class">
								<div slot="content">
									启用时，订单中包含选择的支付方式时，订单需要财务审核，未选择的支付方式的订单不需要财务审核，即自动审核<br/><br/>
									不启用时，全部订单均需要财务审核
								</div>
								<img src="~/images/icon/tooltip-icon.png" class="tip-icon">
							</el-tooltip>
							<div style="display:inline-block;" v-if="payAuditFlag === '1'">
								<div class="span-box" style="width: 182px;margin-left: 20px;">选择需要财务审核的支付方式：</div>
								<el-select size="mini" :disabled="!AuthorityList['06_0001_0002_00']" v-model="payAuditModes" multiple collapse-tags class="select-box" @change="payAuditModesSetting">
									<el-option label="线下支付" value="0"></el-option>
									<el-option label="预付货款" value="4"></el-option>
									<el-option label="微企付" value="6"></el-option>
									<el-option label="微信支付" value="2"></el-option>
								</el-select>
							</div>
						</div>
					</div>
				</el-collapse-item>
				<el-collapse-item title="待发货" name="2">
					<div style="width:50%;float:right">
						<div class="span-box">是否开启申请取消订单提醒：</div>
						<el-select size="mini" :disabled="!AuthorityList['06_0001_0002_00']" v-model="isVioce2" class="select-box" @change="settingVioce(2)">
							<el-option v-for="item in optionList" :value="item.id" :label="item.name" :key="item.id"></el-option>
						</el-select>
					</div>
					<div style="width:50%">
						<div class="span-box">是否启用发货提醒：</div>
						<el-select size="mini" :disabled="!AuthorityList['06_0001_0002_00'] || matchbillcenterflag" v-model="isVioce1" class="select-box" @change="settingVioce(1)">
							<el-option v-for="item in optionList" :value="item.id" :label="item.name" :key="item.id"></el-option>
						</el-select>
					</div>
					<div style="width:50%;margin:20px 0;">
						<div class="span-box">是否允许多发：</div>
						<el-select size="mini" :disabled="!AuthorityList['06_0001_0002_00']" v-model="canUndeliveredOversendFlag" class="select-box" @change="canUndeliveredOversendFlagChange">
							<el-option label="不允许" :value="false"></el-option>
							<el-option label="允许" :value="true"></el-option>
						</el-select>
					</div>
					<div style="width:50%;margin:20px 0;">
						<div class="span-box">是否允许未付款发货：</div>
						<el-select size="mini" :disabled="!AuthorityList['06_0001_0002_00'] || (paymentMethodSetting === 0 && paytype === '1')" v-model="canUndeliveredUnpaySendFlag" class="select-box" @change="canUndeliveredUnpaySendFlagChange">
							<el-option label="不允许" :value="false"></el-option>
							<el-option label="允许" :value="true"></el-option>
						</el-select>
					</div>
				</el-collapse-item>
				<el-collapse-item title="备货中" name="7">
					<div style="width:50%">
						<div class="span-box">是否启用备货中提醒：</div>
						<el-select size="mini" :disabled="!AuthorityList['06_0001_0002_00'] || !matchbillcenterflag" v-model="isVioce3" class="select-box" @change="settingVioce(3)">
							<el-option v-for="item in optionList" :value="item.id" :label="item.name" :key="item.id"></el-option>
						</el-select>
					</div>

					<div v-if="matchbillcenterflag" style="width:50%;margin-top: 20px;">
						<div class="span-box">对接单据的业务时间：</div>
						<el-select size="mini" :disabled="!AuthorityList['06_0001_0002_00']" v-model="matchorderbusdateflag" class="select-box" @change="matchorderbusdateflagChange">
							<el-option :value="0" label="下单时间"></el-option>
							<el-option :value="1" label="备货时间"></el-option>
						</el-select>
					</div>

				</el-collapse-item>
				<el-collapse-item title="待收货" name="4">
					<div style="width:100%;float:right">
						<div class="span-box">是否允许差异收货：</div>
						<el-select :disabled="!AuthorityList['06_0001_0002_00']" size="mini" v-model="waitForm.difference" class="select-box" @change="differenceChangeHandle()">
							<el-option label="不允许差异收货" :value="0"></el-option>
							<el-option label="仅允许少收" :value="1"></el-option>
							<el-option label="允许多收少收" :value="2"></el-option>
						</el-select>
						<el-tooltip effect="dark" placement="right" popper-class="tip-class">
							<div slot="content">如果“不允许差异收货”且“启用分批收货”，则卖家每次发货后，买家可以立即收货，例如订货10，卖家第一次发3，买家可以先收3，但买家不可以收2。<br/><br/>
							如果“允许差异收货”且“不启用分批收货”，则在卖家完成发货前，买家不能收货，只有卖家全部发货后，买家才能一次性收货。买家收货数量可以不等于卖家发货数量。<br/><br/>
							如果“不允许差异收货”且“不启用分批收货”，则在卖家完成发货前，买家不能收货，只有卖家全部发货后，买家才能一次性收货。买家收货数量必须等于卖家发货数量。</div>
							<img src="~/images/icon/tooltip-icon.png" class="tip-icon">
						</el-tooltip>
					</div>
					<div style="width:100%;float:right;margin:20px 0;">
						<div class="span-box">是否启用分批收货功能：</div>
						<el-select :disabled="!AuthorityList['06_0001_0002_00']" size="mini" v-model="waitForm.separate" class="select-box" @change="separateChangeHandle()">
							<el-option label="不启用" value="0"></el-option>
							<el-option label="启用" value="1"></el-option>
						</el-select>
					</div>
				</el-collapse-item>
				<el-collapse-item title="已完成" name="5">
					<div style="width:100%;float:right">
						<div class="span-box">订单修改实收数：</div>
						<span>卖家</span>
						<el-input  :disabled="!AuthorityList['06_0001_0002_00']" v-model="editReciveDateLimit" @blur="changeGetCount" size='mini' type='number' class="input-box number" style="width: 140px;margin: 0 20px 20px 5px;"></el-input>
						<span>天可修改买家实收数</span>
						<span style="color:red;margin-left:50px">注：修改实收数有引起客诉的风险，请谨慎操作！</span>
					</div>
					<div style="width:100%;float:right">
						<div class="span-box">店铺自动收货时间：</div>
						<el-select size="mini" :disabled="!AuthorityList['06_0001_0002_00']" v-model="autoReceiptDateType" class="select-box" style="margin-bottom:20px;margin-right:20px" @change="autoReceiptDateTypeChange">
							<el-option :value="0" label="按集团"></el-option>
							<el-option :value="1" label="按店铺"></el-option>
						</el-select>
						<div class="auto-receive-box" v-if="autoReceiptDateType === 0">
							<span>确认发货后</span>
							<el-input :disabled="!AuthorityList['06_0001_0002_00']" v-model="autoReceiptDate" @blur="changeAutoReceiptDate" size='mini' class="input-box number" style="width: 140px;margin: 0 20px 20px 5px;"></el-input>
							<span>天自动收货</span>
						</div>
						<el-button size="mini" v-else :disabled="!AuthorityList['06_0001_0002_00']" type="primary" @click="autoShopClick">按店铺设置</el-button>
					</div>
					<div style="width:100%;margin:20px 0;">
						<div class="span-box">自动收货前允许手动收货：</div>
						<el-select :disabled="!AuthorityList['06_0001_0002_00']" size="mini" v-model="receiveBySelf" class="select-box" @change="receiveBySelfChange">
							<el-option label="否" :value="0"></el-option>
							<el-option label="是" :value="1"></el-option>
						</el-select>
					</div>
					<div style="width:100%;float:right">
						<div class="span-box">已完成订单在</div>
						<el-input  :disabled="!AuthorityList['06_0001_0002_00']" v-model="invoiceOrderDaysLimit" @blur="changeInvoiceOrderDaysLimit" size='mini' type='number' class="input-box number" style="width: 140px;margin: 0 20px 20px 5px;"></el-input>
						<span>天内，允许线上开票</span>
						<span style="color:red;margin-left:50px">注：0天代表没限制！</span>
					</div>
				</el-collapse-item>
				<el-collapse-item title="退货单" name="8">
					<div style="width:50%;float: right;">
						<div class="span-box">订单状态变更为已完成后</div>
						<el-input :disabled="!AuthorityList['06_0001_0002_00']" v-model="canRefundDate" @blur="canRefundDateChange" size='mini' type='number' min='0' max='999' class="input-box number" style="width: 140px;margin: 0 5px 20px 5px;"></el-input>
						<div class="span-box" style="text-align: left;">日内支持发起退货申请</div>
					</div>
					<div style="width:50%">
						<div class="span-box">是否启用申请退货提醒：</div>
						<el-select size="mini" :disabled="!AuthorityList['06_0001_0002_00']" v-model="isVioce4" class="select-box" @change="settingVioce(4)">
							<el-option v-for="item in optionList" :value="item.id" :label="item.name" :key="item.id"></el-option>
						</el-select>
					</div>
					<div style="width:50%;margin:20px 0;">
						<div class="span-box" style="width:200px;">代客退单是否受退货时限控制：</div>
						<el-select :disabled="!AuthorityList['06_0001_0002_00']" size="mini" v-model="ffclbcrdFlag" class="select-box" @change="ffclbcrdFlagChange">
							<el-option label="否" :value="0"></el-option>
							<el-option label="是" :value="1"></el-option>
						</el-select>
					</div>
					<div style="width:50%;margin:20px 0;">
						<div class="span-box" style="width:200px;">退货必须上传附件：</div>
						<el-select :disabled="!AuthorityList['06_0001_0002_00']" size="mini" v-model="refundOrderMustAtta" class="select-box" @change="refundOrderMustAttaChange">
							<el-option label="否" :value="0"></el-option>
							<el-option label="是" :value="1"></el-option>
						</el-select>
					</div>
				</el-collapse-item>
				<el-collapse-item title="其他" name="10">
					<div>
						<div class="span-box">期望到货时间默认值设置：</div>
						<el-select size="mini" :disabled="!AuthorityList['06_0001_0002_00']" v-model="defaultWantArrivalDateType" class="select-box" style="margin-bottom:20px;margin-right:20px" @change="defaultWantArrivalDateTypeChange">
							<el-option :value="0" label="按集团"></el-option>
							<el-option :value="1" label="按店铺"></el-option>
						</el-select>
						<div class="auto-receive-box" v-if="defaultWantArrivalDateType === 0">
							<span>订单创建时间 +</span>
							<el-input :disabled="!AuthorityList['06_0001_0002_00']" v-model="defaultWantArrivalDate" @blur="changeDefaultWantArrivalDate" size='mini' class="input-box number" style="width: 140px;margin: 0 20px 20px 5px;"></el-input>
							<span>天</span>
						</div>
						<el-button size="mini" v-else :disabled="!AuthorityList['06_0001_0002_00']" type="primary" @click="expectShopClick">按店铺设置</el-button>
					</div>
				</el-collapse-item>
			</el-collapse>
		</div>
		<el-dialog top='60px' title="按店铺设置" :close-on-click-modal="false" :append-to-body="true" :visible.sync="autoShopDialog" width='800px'>
			<div style="max-height: 400px;margin-top: 10px;">
				<el-table
				:stripe='true'
				ref='table'
				size='mini'
				class="grid-content"
				:data="tableData"
				:height="400"
				border>
				<el-table-column
					prop="name"
					label="店铺"
					align="center"
					min-width="100">
				</el-table-column>
				<el-table-column
					prop="autoReceiptDate"
					label="自动收货时间"
					align="center"
					min-width="180">
					<template slot-scope='scope'>
						<div class="auto-receive-box">
							<span>确认发货后</span>
							<el-input :disabled="!AuthorityList['06_0001_0002_00']" v-model="scope.row.autoReceiptDate" @blur="changeAutoShopDate(scope.$index)" size='mini' class="input-box number" style="width: 140px;margin: 5px 20px;"></el-input>
							<span>天自动收货</span>
						</div>
					</template>
				</el-table-column>
				</el-table>
			</div>
			<div style="width: 100%;height: 60px;margin-top: 20px;display: flex;align-items: center;justify-content: center;">
				<el-button @click='autoShopClose' size='small'>取消</el-button>
				<el-button @click='autoShopEnsure' size='small' type="primary">确认</el-button>
			</div>
		</el-dialog>
		<el-dialog top='60px' title="按店铺设置" :close-on-click-modal="false" :append-to-body="true" :visible.sync="expectShopDialog" width='800px'>
			<div style="max-height: 400px;margin-top: 10px;">
				<el-table
				:stripe='true'
				ref='table'
				size='mini'
				class="grid-content"
				:data="tableData"
				:height="400"
				border>
				<el-table-column
					prop="name"
					label="店铺"
					align="center"
					min-width="100">
				</el-table-column>
				<el-table-column
					prop="userNumber"
					label="期望到货时间默认值设置"
					align="center"
					min-width="180">
					<template slot-scope='scope'>
						<div class="auto-receive-box">
							<span>订单创建时间 +</span>
							<el-input :disabled="!AuthorityList['06_0001_0002_00']" v-model="scope.row.defaultwantarrivaldate" @blur="changeExpectShopDate(scope.$index)" size='mini' class="input-box number" style="width: 140px;margin: 5px 20px;"></el-input>
							<span>天</span>
						</div>
					</template>
				</el-table-column>
				</el-table>
			</div>
			<div style="width: 100%;height: 60px;margin-top: 20px;display: flex;align-items: center;justify-content: center;">
				<el-button @click='expectShopClose' size='small'>取消</el-button>
				<el-button @click='expectShopEnsure' size='small' type="primary">确认</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
import bindShop from '@/components/bindShop/bindShop.vue'

export default {
	name: 'orderSetting',
	components: {
		bindShop
	},
	data () {
		return {
			optionList: [
				{
					id: 0,
					name: '不启用'
				},
				{
					id: 3,
					name: '同时启用语音和弹窗提醒'
				},
				{
					id: 1,
					name: '仅启用语音提醒'
				},
				{
					id: 2,
					name: '仅启用弹窗提醒'
				}
			],
			isVioce: null,
			isVioce1: null,
			isVioce2: null,
			isVioce3: null,
			isVioce4: null,
			needAuditingFlag: false,
			canUndeliveredOversendFlag: false,
			canUndeliveredUnpaySendFlag: true,
			activeNames: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10'],
			form: {
				difference: '0',
				difference2: '0',
				financialAuditFlag: '0'
			},
			refundForm: {
				difference: '0'
			},
			waitForm: {
				difference: 0,
				separate: '0'
			},
			acceptData: '',
			confirmContent: '',
			newconfirmContent: '',
			bool: true,
			AuthorityList: {
				'06_0001_0001_00': false,
				'06_0001_0002_00': false
			},
			sendValue: 0,
			acceptSendValue: 0,
			refundValue: 0,
			acceptFefundValue: 0,
			clddock: 0,
			timedreceiveorderflag: 0,
			timedreceiveordertime: 0,
			dreceivetimeFlag: true,
			shopid: '',
			autoReceiptDate: 15,
			editReciveDateLimit: '',
			acceptData2: null,
			invalidTime: 2,
			timeFlag: true,
			matchbillcenterflag: null,
			defaultWantArrivalDate: null,
			canRefundDate: null,
			matchorderbusdateflag: null,
			autoprint: '0',
			printname: '',
			printerOptions: [],
			paytype: '0',
			paymentMethodSetting: 0,
			itemsBranch0: [],
			itemsBranch1: [],
			checkedStatusBranch1: [],
			statusBranch1: [],
			shopPaymentDialogVisible: false,
			shopPaymentTransferCanPayLater: false,
			shopPayment: {},
			shopPaymentChooseShop: [],
			shopPaymentSaveLoading: false,
			payAuditFlag: '0',
			payAuditModes: ['0'],
			ffclbcrdFlag: 1,
			receiveBySelf: 0,
			autoReceiptDateType: 0,
			autoShopDialog: false,
			tableData: [],
			defaultWantArrivalDateType: 0,
			refundOrderMustAtta: 0,
			invoiceOrderDaysLimit: 0,
			expectShopDialog: false,
			items: [],
			items1: [
				{ name: '待接单', id: 1, active: true },
				{ name: '财务审核', id: 6, active: true },
				{ name: '待发货', id: 2, active: true },
				{ name: '备货中', id: 2, active: true },
				{ name: '待收货', id: 3, active: true },
				{ name: '已完成', id: 4, active: true }
			],
			items3: [
				{ name: '待付款', id: 0, active: true },
				{ name: '待接单', id: 1, active: true },
				{ name: '财务审核', id: 6, active: true },
				{ name: '待发货', id: 2, active: true },
				{ name: '备货中', id: 2, active: true },
				{ name: '待收货', id: 3, active: true },
				{ name: '已完成', id: 4, active: true }
			],
			items2: [
				{ name: '待接单', id: 1, active: true },
				{ name: '待付款', id: 0, active: true },
				{ name: '财务审核', id: 6, active: true },
				{ name: '待发货', id: 2, active: true },
				{ name: '备货中', id: 2, active: true },
				{ name: '待收货', id: 3, active: true },
				{ name: '已完成', id: 4, active: true }
			],
			status: [],
			status1: [
				// { name: '待接单', id: '1' },
				{ name: '财务审核', id: '6' },
				{ name: '待发货', id: '2' },
				{ name: '待收货', id: '3' },
				{ name: '已完成', id: '4' }
			],
			status2: [
				// { name: '待接单', id: '1' },
				{ name: '财务审核', id: '6' },
				{ name: '备货中', id: '2' },
				{ name: '待收货', id: '3' },
				{ name: '已完成', id: '4' }
			],
			checkedStatus: [],
			mapOpj: {},
			isRed: false,
			ruleForm: {},
			fxDataVerification: this.$fxUtils.fxDataVerification(),
			reconciliationShow: false,
			idArr: [
				'720926033196351488',
				'768787951533555712',
				'1164504057801474048',
				'1099638795021713408',
				'1089522117940215808'
			]
		}
	},
	created () {
		// let syscodeid = window.sessionStorage.getItem('entid')
		// this.reconciliationShow = this.idArr.includes(syscodeid)
		this.getSyscodeid()
		this.$fxEventBus.$emit('setMenu', '7-2')
		this.getAuthority('06_0001_0000_00')
		this.findShopList().then((data) => {
			if (data.length > 0) {
				this.shopid = data[0].shopId
				window.sessionStorage.setItem('shopid', this.shopid)
				this.findall()
			}
		})
	},
	mounted () {
	},
	methods: {
		goStaff () {
			this.$router.push(`/main/personnelManage`)
		},
		getSyscodeid () {
			let formData = new FormData()
			formData.append('funname', 'timedreceiveorder')
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/organ/customized`,
				data: formData
			}).then(res => {
				if (res.result) {
					let syscodeid = window.sessionStorage.getItem('entid')
					this.reconciliationShow = res.data.timedreceiveorder.includes(syscodeid)
				}
			})
		},
		matchorderbusdateflagChange () {
			let formData = new FormData()
			formData.append('matchorderbusdateflag', this.matchorderbusdateflag)
			this.ruleForm.matchorderbusdateflag = this.matchorderbusdateflag
			const logger = this.$fxLogger.createInfo('system.order-setting.update', this.createLoggerParams())
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIV}/shop/systemcenter/matchorganinfo/setMatchOrderBusdateFlag`,
				data: formData,
				logger
			}).then(res => {
				if (res.result) {
					this.$message.success(res.msg)
					this.findall()
				} else {
					this.$message.error(res.msg)
				}
			})
		},
		autoReceiptDateTypeChange () {
			let formData = new FormData()
			formData.append('autoReceiptDateType', this.autoReceiptDateType)
			const preState = this.autoReceiptDateType === 1 ? '按集团' : '按店铺'
			const curState = this.autoReceiptDateType === 0 ? '按集团' : '按店铺'
			let loggerMessage = `店铺自动收货时间由"${preState}"改为"${curState}"`
			formData.append('message', loggerMessage)
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIV}/shop/systemcenter/matchorganinfo/setAutoReceiptDateType`,
				data: formData
			}).then(res => {
				if (res.result) {
					this.$message.success(res.msg)
					this.findall()
				} else {
					this.$message.error(res.msg)
				}
			})
		},
		autoShopClick () {
			this.getAutoShop()
			this.autoShopDialog = true
		},
		autoShopClose () {
			this.autoShopDialog = false
		},
		autoShopEnsure () {
			let autoReceiptDateInfos = []
			let msgArr = []
			this.tableData.forEach(item => {
				let obj = {
					shopid: item.id,
					autoReceiptDate: +item.autoReceiptDate
				}
				autoReceiptDateInfos.push(obj)
				let msg = `店铺${item.name}自动收货时间修改为${item.autoReceiptDate}`
				msgArr.push(msg)
			})
			let params = {
				autoReceiptDateInfos: autoReceiptDateInfos,
				message: msgArr.join(';')
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIV}/shop/systemcenter/matchorganinfo/updateShopToAutoReceiptDate`,
				data: params
			}).then(res => {
				if (res.result) {
					this.$message.success(res.msg)
					this.autoShopDialog = false
					this.findall()
				} else {
					this.$message.error(res.msg)
				}
			})
		},
		getAutoShop () {
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIV}/shop/findShopInfoBySyscode`
			}).then(res => {
				if (res.result) {
					this.tableData = res.data
					// this.$message.success(res.msg)
				} else {
					this.tableData = []
					this.$message.error(res.msg)
				}
			})
		},


		defaultWantArrivalDateTypeChange () {
			let formData = new FormData()
			formData.append('defaultWantArrivalDateType', this.defaultWantArrivalDateType)
			const preState = this.defaultWantArrivalDateType === 1 ? '按集团' : '按店铺'
			const curState = this.defaultWantArrivalDateType === 0 ? '按集团' : '按店铺'
			let loggerMessage = `期望到货时间默认值设置由"${preState}"改为"${curState}"`
			formData.append('message', loggerMessage)
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIV}/shop/systemcenter/matchorganinfo/setDefaultWantArrivalDateType`,
				data: formData
			}).then(res => {
				if (res.result) {
					this.$message.success(res.msg)
					this.findall()
				} else {
					this.$message.error(res.msg)
				}
			})
		},
		expectShopClick () {
			this.getAutoShop()
			this.expectShopDialog = true
		},
		expectShopClose () {
			this.expectShopDialog = false
		},
		expectShopEnsure () {
			let defaultWantArrivalDateInfos = []
			let msgArr = []
			this.tableData.forEach(item => {
				let obj = {
					shopid: item.id,
					defaultWantArrivalDate: +item.defaultwantarrivaldate
				}
				defaultWantArrivalDateInfos.push(obj)
				let msg = `店铺${item.name}期望到货时间默认值设置修改为订单创建时间 +${item.defaultwantarrivaldate}天`
				msgArr.push(msg)
			})
			let params = {
				defaultWantArrivalDateInfos: defaultWantArrivalDateInfos,
				message: msgArr.join(';')
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIV}/shop/systemcenter/matchorganinfo/saveShopToDefaultWantArrivalDate`,
				data: params
			}).then(res => {
				if (res.result) {
					this.$message.success(res.msg)
					this.expectShopDialog = false
					this.findall()
				} else {
					this.$message.error(res.msg)
				}
			})
		},
		canRefundDateChange () {
			var r = /^-?[1-9]\d*$|^(0)$/
			if (r.test(this.canRefundDate)) {
				let formData = new FormData()
				formData.append('canRefundDate', this.canRefundDate)
				this.ruleForm.canRefundDate = this.canRefundDate
				const logger = this.$fxLogger.createInfo('system.order-setting.update', this.createLoggerParams())
				this.$store.dispatch('requestPost', {
					url: `${this.$fxBaseApi.urlQIV}/shop/systemcenter/matchorganinfo/setCanRefundDate`,
					data: formData,
					logger
				}).then(res => {
					if (res.result) {
						this.$message.success(res.msg)
						this.findall()
					} else {
						this.$message.error(res.msg)
					}
				})
			} else {
				this.$message.error('请输入整数！')
				return false
			}
		},
		canUndeliveredUnpaySendFlagChange () {
			let formData = new FormData()
			formData.append('canUndeliveredUnpaySendFlag', this.canUndeliveredUnpaySendFlag)
			this.ruleForm.canUndeliveredUnpaySendFlag = this.canUndeliveredUnpaySendFlag
			const logger = this.$fxLogger.createInfo('system.order-setting.update', this.createLoggerParams())
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIV}/shop/systemcenter/matchorganinfo/setCanUndeliveredUnpaySendFlag`,
				data: formData,
				logger
			}).then(res => {
				if (res.result) {
					this.$message.success(res.msg)
					this.findall()
				}
			})
		},
		canUndeliveredOversendFlagChange () {
			let formData = new FormData()
			formData.append('canUndeliveredOversendFlag', this.canUndeliveredOversendFlag)
			this.ruleForm.canUndeliveredOversendFlag = this.canUndeliveredOversendFlag
			const logger = this.$fxLogger.createInfo('system.order-setting.update', this.createLoggerParams())
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIV}/shop/systemcenter/matchorganinfo/setCanUndeliveredOversendFlag`,
				data: formData,
				logger
			}).then(res => {
				if (res.result) {
					this.$message.success(res.msg)
					this.findall()
				}
			})
		},
		needAuditingFlagChange () {
			let formData = new FormData()
			formData.append('needAuditingFlag', this.needAuditingFlag)
			this.ruleForm.needAuditingFlag = this.needAuditingFlag
			const logger = this.$fxLogger.createInfo('system.order-setting.update', this.createLoggerParams())
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIV}/shop/systemcenter/matchorganinfo/setNeedAuditingFlag`,
				data: formData,
				logger
			}).then(res => {
				if (res.result) {
					this.$message.success(res.msg)
					this.findall()
				}
			})
		},
		// 是否启用定时接单
		timedreceiveorderflagChange () {
			let formData = new FormData()
			formData.append('timedreceiveorderflag', this.timedreceiveorderflag)
			this.ruleForm.timedreceiveorderflag = this.timedreceiveorderflag
			const logger = this.$fxLogger.createInfo('system.order-setting.update', this.createLoggerParams())
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIV}/shop/systemcenter/matchorganinfo/setTimedReceiveOrderFlag`,
				data: formData,
				logger
			}).then(res => {
				if (res.result) {
					this.$message.success(res.msg)
					this.findall()
				}
			})
		},
		// 打印相关js文件均在public文件夹下index.html文件引入
		deviceInit () {
			let _this = this
			if (navigator.userAgent.indexOf('Windows') < 0) {
				this.$message.error('请在 Windows 系统中使用自定义打印！')
				return false
			}
			// 初始化打印
			/* eslint-disable-next-line */
			TDevices.init().then(() => {
				// 获取打印机
				_this.getPrinter()
				// 获取模板
				_this.getTemplate()
			})
		},
		getPrinter () {
			let _this = this
			// 实例化一个打印机相关的对象，获取打印机列表
			/* eslint-disable-next-line */
			let report = new FastReport()
			report.enable = true
			report.printerlist(function (result) {
				var printerList = result.message.list
				printerList.forEach(item => {
					_this.printerOptions.push({
						value: item,
						label: item
					})
				})
				_this.printerValue = _this.printerOptions[0].value
			})
		},
		autoprintChange (e) {
			if (e === '1') {
				this.deviceInit()
			}
			if (e === '0' || (e === '1' && this.printname)) {
				let formData = new FormData()
				formData.append('value', this.autoprint)
				formData.append('printname', this.printname)
				this.ruleForm.autoprint = this.autoprint
				const logger = this.$fxLogger.createInfo('system.order-setting.update', this.createLoggerParams())
				this.$store.dispatch('requestPost', {
					url: `${this.$fxBaseApi.urlQIV}/shop/systemcenter/matchorganinfo/setAutoPrintOrder`,
					data: formData,
					logger
				}).then(res => {
					if (res.res) {
						this.$message.success(res.msg)
						this.findall()
					}
				})
			}
		},
		printnameChange () {
			let formData = new FormData()
			formData.append('value', this.autoprint)
			formData.append('printname', this.printname)
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIV}/shop/systemcenter/matchorganinfo/setAutoPrintOrder`,
				data: formData
			}).then(res => {
				if (res.res) {
					this.$message.success(res.msg)
					this.findall()
				}
			})
		},
		settingVioce (type) {
			let formData = new FormData()
			formData.append('type', type)
			switch (type) {
			case 0:
				formData.append('value', this.isVioce)
				this.ruleForm.isVioce = this.isVioce
				break
			case 1:
				formData.append('value', this.isVioce1)
				this.ruleForm.isVioce1 = this.isVioce1
				break
			case 2:
				formData.append('value', this.isVioce2)
				this.ruleForm.isVioce2 = this.isVioce2
				break
			case 3:
				formData.append('value', this.isVioce3)
				this.ruleForm.isVioce3 = this.isVioce3
				break
			case 4:
				formData.append('value', this.isVioce4)
				this.ruleForm.isVioce4 = this.isVioce4
				break
			}
			const logger = this.$fxLogger.createInfo('system.order-setting.update', this.createLoggerParams())
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIV}/shop/systemcenter/matchorganinfo/setSoundRemind`,
				data: formData,
				logger
			}).then(res => {
				if (res.res) {
					this.$message.success(res.msg)
					this.findall()
				}
			})
		},
		getAuthority (data) {
			let params = {
				pId: data
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlIV}/account/authority/getUserAuthority`,
				data: params
			}).then(res => {
				if (res.result) {
					let a = res.data
					for (let i = 0; i < a.length; i++) {
						this.AuthorityList[a[i]] = true
					}
				}
			})
		},
		settingChange () {
			if (this.form.difference === '0') {
				this.form.difference2 = '0'
				this.isVioce = 0
				this.settingVioce(0)
			}
			this.settingPost()
		},
		canDirectSendSetting () {
			let canDirectSendflag
			if (this.form.difference2 === '1') {
				canDirectSendflag = true
			} else {
				canDirectSendflag = false
			}
			let formData = new FormData()
			formData.append('canDirectSendflag', canDirectSendflag)
			this.ruleForm.difference2 = this.form.difference2
			const logger = this.$fxLogger.createInfo('system.order-setting.update', this.createLoggerParams())
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/systemcenter/matchorganinfo/setCanDirectSendflag`,
				data: formData,
				logger
			}).then(res => {
				if (res.result) {
					this.findall()
					this.$message.success('设置成功')
				} else {
					this.$message.error(res.msg)
					this.findall()
				}
			}).catch(err => {
				this.$message.error(err.msg)
				this.findall()
			})
		},
		refundOrderMustAttaChange () {
			let formData = new FormData()
			formData.append('refundOrderMustAtta', this.refundOrderMustAtta)
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/systemcenter/matchorganinfo/setRefundOrderMustAtta`,
				data: formData
			}).then(res => {
				if (res.result) {
					this.findall()
					this.$message.success(res.msg)
				} else {
					this.$message.error(res.msg)
				}
			}).catch(err => {
				this.$message.error(err.msg)
			})
		},
		receiveBySelfChange () {
			let formData = new FormData()
			formData.append('receiveBySelf', this.receiveBySelf)
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/systemcenter/matchorganinfo/receiveBySelf`,
				data: formData
			}).then(res => {
				if (res.result) {
					this.findall()
					this.$message.success(res.msg)
				} else {
					this.$message.error(res.msg)
				}
			}).catch(err => {
				this.$message.error(err.msg)
			})
		},
		ffclbcrdFlagChange () {
			let formData = new FormData()
			formData.append('ffclbcrdFlag', this.ffclbcrdFlag)
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/systemcenter/matchorganinfo/setFfclbcrdFlag`,
				data: formData
			}).then(res => {
				if (res.result) {
					this.findall()
					this.$message.success(res.msg)
				} else {
					this.$message.error(res.msg)
				}
			}).catch(err => {
				this.$message.error(err.msg)
			})
		},
		payAuditFlagSetting () {
			const preState = this.payAuditFlag === '1' ? '不启用' : '启用'
			const curState = this.payAuditFlag === '0' ? '不启用' : '启用'
			let loggerMessage = `是否启用根据支付方式审核由"${preState}"改为"${curState}"`
			let loggerUrl = window.location.href.split('?')[0]
			loggerUrl = loggerUrl.replace(window.location.origin, '').substring(1)
			const params = {
				payAuditFlag: +this.payAuditFlag,
				message: loggerMessage,
				referer: loggerUrl
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/systemcenter/matchorganinfo/setPayAuditFlag`,
				data: params
			}).then(res => {
				if (res.result) {
					this.findall()
					this.$message.success(res.msg)
				} else {
					this.$message.error(res.msg)
				}
			}).catch(err => {
				this.$message.error(err.msg)
			})
		},
		payAuditModesSetting (e) {
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/systemcenter/matchorganinfo/setPayAuditModes?refundOrderMustAtta=${this.refundOrderMustAtta}`
			}).then(res => {
				if (res.result) {
					this.findall()
					this.$message.success(res.msg)
				} else {
					this.findall()
					this.$message.error(res.msg)
				}
			}).catch(err => {
				this.$message.error(err.msg)
			})
		},
		createLoggerParams () {
			const originData = this.fxDataVerification.getOriginData()
			const ruleForm = this.$fxUtils.deepClone(this.ruleForm)
			return {
				pre: originData,
				cur: ruleForm
			}
		},
		findall () {
			let formData = new FormData()
			formData.append('shopid', this.shopid)
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/systemcenter/findall`,
				data: formData
			}).then(res => {
				if (res.result) {
					this.checkedStatus = []
					this.items = []
					this.refundOrderMustAtta = res.data.pmdata.refundOrderMustAtta
					this.receiveBySelf = res.data.pmdata.receiveBySelf
					this.invoiceOrderDaysLimit = res.data.pmdata.invoiceOrderDaysLimit
					this.canRefundDate = res.data.canRefundDate
					this.matchbillcenterflag = res.data.matchbillcenterflag === 1
					this.needAuditingFlag = res.data.needAuditingFlag
					this.canUndeliveredOversendFlag = res.data.canUndeliveredOversendFlag
					this.canUndeliveredUnpaySendFlag = res.data.canUndeliveredUnpaySendFlag
					this.isVioce = res.data.waosound
					this.isVioce1 = res.data.wsgsound
					this.isVioce2 = res.data.acosound
					this.isVioce3 = res.data.pposound
					this.defaultWantArrivalDate = res.data.defaultWantArrivalDate
					this.matchorderbusdateflag = res.data.matchorderbusdateflag
					this.isVioce4 = res.data.arosound
					this.acceptData = res.data.waitingOrder ? '1' : '0'
					this.form.difference = res.data.waitingOrder ? '1' : '0'
					this.refundForm.difference = '' + res.data.pushdiffrefundorder
					this.paytype = res.data.canpaylater ? '1' : '0'
					let paymentMethodRaw
					if (res.data.pmdata && res.data.pmdata.paymentMethodSetting !== undefined && res.data.pmdata.paymentMethodSetting !== null) {
						paymentMethodRaw = res.data.pmdata.paymentMethodSetting
					} else if (res.data.paymentMethodSetting !== undefined && res.data.paymentMethodSetting !== null) {
						paymentMethodRaw = res.data.paymentMethodSetting
					} else {
						paymentMethodRaw = 0
					}
					this.paymentMethodSetting = Number(paymentMethodRaw) === 1 ? 1 : 0
					this.shopPayment = res.data.shopPayment || {}
					this.autoReceiptDateType = res.data.autoReceiptDateType
					this.defaultWantArrivalDateType = res.data.defaultWantArrivalDateType
					if (this.paytype === '1') {
						this.items = this.items.concat(this.items1)
					} else {
						if (this.needAuditingFlag) {
							this.items = this.items.concat(this.items2)
						} else {
							this.items = this.items.concat(this.items3)
						}
					}
					if (this.form.difference === '1') {
						this.items.forEach(item => {
							if (item.name === '待接单') {
								item.active = true
							}
						})
					} else {
						this.items.forEach(item => {
							if (item.name === '待接单') {
								item.active = false
							}
						})
					}
					this.form.difference2 = res.data.canDirectSendflag ? '1' : '0'
					this.form.financialAuditFlag = res.data.needFinancialAuditingFlag ? '1' : '0'
					if (this.form.financialAuditFlag === '1') {
						this.items.forEach(item => {
							if (item.name === '财务审核') {
								item.active = true
							}
						})
					} else {
						this.items.forEach(item => {
							if (item.name === '财务审核') {
								item.active = false
							}
						})
					}
					if (!res.data.waitingOrder) {
						this.confirmContent = '订单支付成功后，订单状态直接变成待发货状态！'
					} else {
						if (res.data.needAuditingFlag) {
							this.confirmContent = '买家下单后，订单状态变更为待接单状态，卖家接单后可继续付款！'
						} else {
							this.confirmContent = '订单支付成功后，订单状态变更为待接单状态!'
						}
					}
					// this.confirmContent = res.data.waitingOrder ? '订单支付成功后，订单状态变成待接单状态！' : '订单支付成功后，订单状态直接变成待发货状态！'
					this.sendValue = res.data.backorderdock
					this.refundValue = res.data.overrefunddock
					this.clddock = res.data.clddock
					this.acceptData2 = res.data.buyerDifferFlag
					this.waitForm.difference = res.data.buyerDifferFlag
					this.waitForm.separate = JSON.stringify(res.data.batchReceiveFlag)
					this.autoReceiptDate = res.data.autoReceiptDate
					// console.log(this.autoReceiptDate)
					this.editReciveDateLimit = res.data.editReciveDateLimit
					this.invalidTime = res.data.unpaidInvalidTime
					this.autoprint = res.data.autoprintflag + ''
					this.printname = res.data.printname
					this.timedreceiveorderflag = res.data.timedreceiveorderflag
					this.timedreceiveordertime = res.data.timedreceiveordertime
					this.payAuditFlag = res.data.payAuditFlag.toString()
					this.payAuditModes = res.data.payAuditModes
					this.ffclbcrdFlag = res.data.ffclbcrdFlag
					if (this.autoprint === '1') {
						this.deviceInit()
					}
					if (!this.matchbillcenterflag) {
						this.items.splice(this.items.findIndex(item => item.name === '备货中'), 1)
						this.status = this.status1
					} else {
						this.items.splice(this.items.findIndex(item => item.name === '待发货'), 1)
						this.status = this.status2
					}
					if (res.data.canPayStatuses) {
						res.data.canPayStatuses.forEach(item => {
							this.status.forEach(item2 => {
								if ('' + item === item2.id) {
									this.checkedStatus.push(item2.name)
								}
							})
						})
						this.checkedStatus = Array.from(new Set(this.checkedStatus))
					}
					this.refreshBranchFlowItems()
					if (this.needAuditingFlag) {
						this.isRed = true
					} else {
						this.isRed = false
					}
					this.ruleForm = {
						paymentMethodSetting: this.paymentMethodSetting,
						paytype: this.paytype,
						invoiceOrderDaysLimit: this.invoiceOrderDaysLimit,
						needAuditingFlag: this.needAuditingFlag,
						invalidTime: this.invalidTime,
						isVioce: this.isVioce,
						difference2: this.form.difference2,
						waitingOrder: this.form.difference,
						autoprint: this.autoprint,
						isVioce2: this.isVioce2,
						isVioce1: this.isVioce1,
						canUndeliveredOversendFlag: this.canUndeliveredOversendFlag,
						canUndeliveredUnpaySendFlag: this.canUndeliveredUnpaySendFlag,
						isVioce3: this.isVioce3,
						matchorderbusdateflag: this.matchorderbusdateflag,
						defaultWantArrivalDate: this.defaultWantArrivalDate,
						difference: this.waitForm.difference,
						separate: this.waitForm.separate,
						editReciveDateLimit: this.editReciveDateLimit,
						autoReceiptDate: this.autoReceiptDate,
						canRefundDate: this.canRefundDate,
						isVioce4: this.isVioce4,
						financialAuditFlag: this.form.financialAuditFlag,
						timedreceiveorderflag: this.timedreceiveorderflag,
						timedreceiveordertime: this.timedreceiveordertime,
						payAuditFlag: this.payAuditFlag,
						canPayStatuses: (this.checkedStatusBranch1 || []).join(','),
						shopCanPayStatuses: (this.checkedStatusBranch1 || []).join(','),
						shopSelectBeforePay: this.getBranchShopText(false),
						shopSelectAfterPay: this.getBranchShopText(true)
					}
					this.fxDataVerification.resetData(this.ruleForm)
				} else {
					this.$message.error(res.msg)
				}
			}).catch(err => {
				this.$message.error(err.msg)
			})
		},
		settingPost () {
			let formData = new FormData()
			formData.append('waitingOrder', this.form.difference)
			this.ruleForm.waitingOrder = this.form.difference
			const logger = this.$fxLogger.createInfo('system.order-setting.update', this.createLoggerParams())
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/systemcenter/waitingorder`,
				data: formData,
				logger
			}).then(res => {
				if (res.res) {
					this.$message.success('设置成功')
					this.confirmContent = this.form.difference === '1' ? '订单支付成功后，订单状态变成待接单状态！' : '订单支付成功后，订单状态直接变成待发货状态！'
				} else {
					this.$message.error(res.msg)
					this.findall()
				}
			}).catch(err => {
				this.$message.error(err.msg)
				this.findall()
			})
		},
		refundChange () {
			let formData = new FormData()
			formData.append('pushdiffrefundorder', this.refundForm.difference)
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/systemcenter/matchorganinfo4dock`,
				data: formData
			}).then(res => {
				if (res.res) {
					this.$message.success('设置成功')
				} else {
					this.$message.error(res.msg)
					this.findall()
				}
			}).catch(err => {
				this.$message.error(err.msg)
				this.findall()
			})
		},
		matchorgan (type) {
			let formData = new FormData()
			if (type === 'send') {
				formData.append('backorderdock', '' + this.sendValue)
			} else {
				formData.append('overrefunddock', '' + this.refundValue)
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/systemcenter/matchorganinfo4dock`,
				data: formData
			}).then(res => {
				if (res.res) {
					this.$message.success('设置成功')
				} else {
					this.$message.error(res.msg)
					this.findall()
				}
			}).catch(err => {
				this.$message.error(err.msg)
				this.findall()
			})
		},
		tipsHandle (content, type, duration) {
			this.$message({
				message: content,
				type: type,
				duration: duration
			})
		},
		differenceChangeHandle () {
			if (this.waitForm.difference === 0) {
				this.newconfirmContent = '更改后买家在APP的待收货订单不可修改实收数量，是否继续？'
			} else if (this.waitForm.difference === 2) {
				this.newconfirmContent = '更改后买家在APP的待收货订单可修改实收数量，是否继续？'
			} else {
				this.newconfirmContent = '更改后买家在APP的待收货订单可修改实收数量，收货数量 <= 发货数量，是否继续？'
			}
			this.$confirm(this.newconfirmContent, '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning',
				closeOnClickModal: false
			}).then(() => {
				this.differenceChange()
			}).catch(() => {
				this.waitForm.difference = this.acceptData2
			})
		},
		differenceChange () {
			let formData = new FormData()
			formData.append('buyerDifferFlag', this.waitForm.difference)
			this.ruleForm.difference = this.waitForm.difference
			const logger = this.$fxLogger.createInfo('system.order-setting.update', this.createLoggerParams())
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/systemcenter/matchorganinfo/setBuyerDifferFlag`,
				data: formData,
				logger
			}).then(res => {
				if (res.result) {
					this.acceptData2 = this.waitForm.difference
					this.findall()
					this.tipsHandle(res.msg, 'success', 1500)
				} else {
					this.waitForm.difference = this.acceptData2
					this.tipsHandle(res.msg, 'error', 1500)
				}
			})
		},
		separateChangeHandle () {
			let formData = new FormData()
			formData.append('batchReceiveFlag', this.waitForm.separate)
			this.ruleForm.separate = this.waitForm.separate
			const logger = this.$fxLogger.createInfo('system.order-setting.update', this.createLoggerParams())
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/systemcenter/matchorganinfo/setBatchreceive`,
				data: formData,
				logger
			}).then(res => {
				if (res.result) {
					this.findall()
					this.tipsHandle(res.msg, 'success', 1500)
				} else {
					this.tipsHandle(res.msg, 'error', 1500)
				}
			})
		},
		findShopList () {
			return new Promise((resolve, reject) => {
				this.$store.dispatch('requestPost', {
					url: `${this.$fxBaseApi.urlQIVShop}/findshoplist`
				}).then(res => {
					if (res.result) {
						resolve(res.data.shop)
					} else {
						this.$message.error(res.msg)
					}
				}).catch(err => {
					this.$message.error(err.msg)
				})
			})
		},
		changeAutoReceiptDate () {
			this.autoReceiptDate = this.autoReceiptDate.replace(/[^\d.]/g, '')// 清除"数字"和"."以外的字符
			this.autoReceiptDate = this.autoReceiptDate.replace(/^\./g, '')// 验证第一个字符是数字而不是
			this.autoReceiptDate = this.autoReceiptDate.replace(/\.{2,}/g, '.')// 只保留第一个. 清除多余的
			this.autoReceiptDate = this.autoReceiptDate.replace('.', '$#$').replace(/\./g, '').replace('$#$', '.')
			this.autoReceiptDate = this.autoReceiptDate.replace(/^(\-)*(\d+)\.(\d).*$/, '$1$2.$3')
			if (this.autoReceiptDate === '') {
				this.autoReceiptDate = 0
			}
			this.autoReceiptDateHandle()
		},
		changeAutoShopDate (index) {
			this.tableData[index].autoReceiptDate = this.tableData[index].autoReceiptDate.replace(/[^\d.]/g, '')// 清除"数字"和"."以外的字符
			this.tableData[index].autoReceiptDate = this.tableData[index].autoReceiptDate.replace(/^\./g, '')// 验证第一个字符是数字而不是
			this.tableData[index].autoReceiptDate = this.tableData[index].autoReceiptDate.replace(/\.{2,}/g, '.')// 只保留第一个. 清除多余的
			this.tableData[index].autoReceiptDate = this.tableData[index].autoReceiptDate.replace('.', '$#$').replace(/\./g, '').replace('$#$', '.')
			this.tableData[index].autoReceiptDate = this.tableData[index].autoReceiptDate.replace(/^(\-)*(\d+)\.(\d).*$/, '$1$2.$3')
			if (this.tableData[index].autoReceiptDate === '') {
				this.tableData[index].autoReceiptDate = 0
			}
			if (this.tableData[index].autoReceiptDate > 180) {
				this.$message.error('店铺收货时间最大值为180')
				this.tableData[index].autoReceiptDate = 180
				return false
			} else if (this.tableData[index].autoReceiptDate < 0) {
				this.$message.error('店铺收货时间最小值为0')
				this.tableData[index].autoReceiptDate = 0
				return false
			}
		},
		changeExpectShopDate (index) {
			var r = /^-?[1-9]\d*$|^(0)$/
			if (r.test(this.tableData[index].defaultwantarrivaldate)) {
				if (this.tableData[index].defaultwantarrivaldate > 10) {
					this.$message.error('修改期望到货时间最大值为10天')
					this.tableData[index].defaultwantarrivaldate = 10
					return false
				} else if (this.tableData[index].defaultwantarrivaldate < 0) {
					this.$message.error('修改期望到货时间最小值为0天')
					this.tableData[index].defaultwantarrivaldate = 0
					return false
				} else {
					return true
				}
			} else {
				this.$message.error('请输入整数！')
				return false
			}
		},
		checkNum1 () {
			// var r = /^-?[1-9]\d*$|^(0)$/
			// if (r.test(this.autoReceiptDate)) {
			if (this.autoReceiptDate > 180) {
				this.$message.error('店铺收货时间最大值为180')
				return false
			} else if (this.autoReceiptDate < 0) {
				this.$message.error('店铺收货时间最小值为0')
				return false
			} else {
				return true
			}
			// } else {
			// 	this.$message.error('请输入整数！')
			// 	return false
			// }
		},
		checkGetCount () {
			var r = /^-?[1-9]\d*$|^(0)$/
			if (r.test(this.editReciveDateLimit)) {
				if (this.editReciveDateLimit > 45) {
					this.$message.error('修改实收数最大值为45天')
					return false
				} else if (this.editReciveDateLimit < 0) {
					this.$message.error('修改实收数最小值为0天')
					return false
				} else {
					return true
				}
			} else {
				this.$message.error('请输入整数！')
				return false
			}
		},
		autoReceiptDateHandle () {
			if (!this.checkNum1()) {
				return false
			}
			let formData = new FormData()
			formData.append('shopid', this.shopid)
			formData.append('autoReceiptDate', this.autoReceiptDate)
			this.ruleForm.autoReceiptDate = this.autoReceiptDate
			const logger = this.$fxLogger.createInfo('system.order-setting.update', this.createLoggerParams())
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/systemcenter/matchorganinfo/setAutoReceiptDate`,
				data: formData,
				logger
			}).then(res => {
				if (res.result) {
					this.tipsHandle(res.msg, 'success', 1500)
					this.findall()
				} else {
					this.tipsHandle(res.msg, 'error', 1500)
				}
			})
		},
		checkDefaultWantArrivalDate () {
			var r = /^-?[1-9]\d*$|^(0)$/
			if (r.test(this.defaultWantArrivalDate)) {
				if (this.defaultWantArrivalDate > 10) {
					this.$message.error('修改期望到货时间最大值为10天')
					return false
				} else if (this.defaultWantArrivalDate < 0) {
					this.$message.error('修改期望到货时间最小值为0天')
					return false
				} else {
					return true
				}
			} else {
				this.$message.error('请输入整数！')
				return false
			}
		},
		changeDefaultWantArrivalDate () {
			if (!this.checkDefaultWantArrivalDate()) {
				return false
			}
			let formData = new FormData()
			formData.append('defaultWantArrivalDate', this.defaultWantArrivalDate)
			this.ruleForm.defaultWantArrivalDate = this.defaultWantArrivalDate
			const logger = this.$fxLogger.createInfo('system.order-setting.update', this.createLoggerParams())
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/systemcenter/matchorganinfo/setDefaultWantArrivalDate`,
				data: formData,
				logger
			}).then(res => {
				if (res.result) {
					this.tipsHandle(res.msg, 'success', 1500)
					this.findall()
				} else {
					this.tipsHandle(res.msg, 'error', 1500)
				}
			})
		},
		checkInvoiceOrderDaysLimit () {
			var r = /^-?[1-9]\d*$|^(0)$/
			if (r.test(this.invoiceOrderDaysLimit)) {
				if (this.invoiceOrderDaysLimit > 365) {
					this.$message.error('线上开票时间最大值为365天')
					return false
				} else if (this.invoiceOrderDaysLimit < 0) {
					this.$message.error('线上开票时间最小值为0天')
					return false
				} else {
					return true
				}
			} else {
				this.$message.error('请输入整数！')
				return false
			}
		},
		changeInvoiceOrderDaysLimit () {
			if (!this.checkInvoiceOrderDaysLimit()) {
				return false
			}
			let formData = new FormData()
			formData.append('invoiceOrderDaysLimit', this.invoiceOrderDaysLimit)
			this.ruleForm.invoiceOrderDaysLimit = this.invoiceOrderDaysLimit
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/systemcenter/matchorganinfo/invoiceOrderDaysLimit`,
				data: formData
			}).then(res => {
				if (res.result) {
					this.tipsHandle(res.msg, 'success', 1500)
					this.findall()
				} else {
					this.tipsHandle(res.msg, 'error', 1500)
				}
			})
		},
		changeGetCount () {
			if (!this.checkGetCount()) {
				return false
			}
			let formData = new FormData()
			formData.append('editReciveDateLimit', this.editReciveDateLimit)
			this.ruleForm.editReciveDateLimit = this.editReciveDateLimit
			const logger = this.$fxLogger.createInfo('system.order-setting.update', this.createLoggerParams())
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/systemcenter/matchorganinfo/setEditReciveDateLimit`,
				data: formData,
				logger
			}).then(res => {
				if (res.result) {
					this.tipsHandle(res.msg, 'success', 1500)
					this.findall()
				} else {
					this.tipsHandle(res.msg, 'error', 1500)
				}
			})
		},
		changeTime () {
			// var reg1 = /((^[1-9]\d*)|^0)(\.\d{0,1}){0,1}$/
			// if (reg1.test(this.invalidTime)) {
			// 	this.timeFlag = true
			// } else {
			// 	this.timeFlag = false
			// 	return false
			// }
			this.invalidTime = this.invalidTime.replace(/[^\d.]/g, '')// 清除"数字"和"."以外的字符
			this.invalidTime = this.invalidTime.replace(/^\./g, '')// 验证第一个字符是数字而不是
			this.invalidTime = this.invalidTime.replace(/\.{2,}/g, '.')// 只保留第一个. 清除多余的
			this.invalidTime = this.invalidTime.replace('.', '$#$').replace(/\./g, '').replace('$#$', '.')
			this.invalidTime = this.invalidTime.replace(/^(\-)*(\d+)\.(\d).*$/, '$1$2.$3')
			if (+this.invalidTime === 0 || +this.invalidTime < 0.1 || +this.invalidTime > 720) {
				this.timeFlag = false
				return false
			} else {
				this.timeFlag = true
			}
			let formData = new FormData()
			formData.append('unpaidInvalidTime', this.invalidTime)
			this.ruleForm.invalidTime = this.invalidTime
			const logger = this.$fxLogger.createInfo('system.order-setting.update', this.createLoggerParams())
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/systemcenter/matchorganinfo/setUnpaidInvalidTime`,
				data: formData,
				logger
			}).then(res => {
				if (res.result) {
					this.tipsHandle(res.msg, 'success', 1500)
					this.findall()
				} else {
					this.tipsHandle(res.msg, 'error', 1500)
				}
			})
		},
		dreceivetimeChange () {
			var reg1 = /((^[1-9]\d*)|^0)(\.\d{0,1}){0,1}$/
			if (reg1.test(this.timedreceiveordertime)) {
				this.dreceivetimeFlag = true
			} else {
				this.dreceivetimeFlag = false
				return false
			}
			if (+this.timedreceiveordertime < 0 || +this.timedreceiveordertime > 720) {
				this.dreceivetimeFlag = false
				return false
			}
			let formData = new FormData()
			formData.append('timedreceiveordertime', this.timedreceiveordertime)
			this.ruleForm.timedreceiveordertime = this.timedreceiveordertime
			const logger = this.$fxLogger.createInfo('system.order-setting.update', this.createLoggerParams())
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/systemcenter/matchorganinfo/setTimedReceiveOrderTime`,
				data: formData,
				logger
			}).then(res => {
				if (res.result) {
					this.tipsHandle(res.msg, 'success', 1500)
					this.findall()
				} else {
					this.tipsHandle(res.msg, 'error', 1500)
				}
			})
		},
		financialAuditSetting (val) {
			let needFinancialAuditingFlag
			if (val === '1') {
				needFinancialAuditingFlag = true
			} else {
				needFinancialAuditingFlag = false
			}
			let formData = new FormData()
			formData.append('needFinancialAuditingFlag', needFinancialAuditingFlag)
			this.ruleForm.financialAuditFlag = val
			const logger = this.$fxLogger.createInfo('system.order-setting.update', this.createLoggerParams())
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/systemcenter/needFinancialAuditingFlag`,
				data: formData,
				logger
			}).then(res => {
				if (res.result) {
					this.tipsHandle(res.msg, 'success', 1500)
					this.findall()
				} else {
					this.tipsHandle(res.msg, 'error', 1500)
				}
			})
		},
		paytypeChange (val) {
			let that = this
			if (val === '1') {
				this.$alert('系统设置-基础档案-订单生成设置-有未付款单据是否继续下单变成可以下单。如果继续想控制有未付款单据下单的话，可以对客户开启信用额度设置！', '提示', {
					confirmButtonText: '我知道了',
					callback: action => {
						if (action === 'confirm') {
							that.paytypeChangeHandle(val)
						} else if (action === 'cancel') {
							that.paytype = '0'
						}
					}
				})
			} else {
				that.paytypeChangeHandle(val)
			}
		},
		paytypeChangeHandle (val) {
			let formData = new FormData()
			formData.append('canPayLater', val)
			this.ruleForm.paytype = val
			const logger = this.$fxLogger.createInfo('system.order-setting.update', this.createLoggerParams())
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/systemcenter/matchorganinfo/setCanPayLater`,
				data: formData,
				logger
			}).then(res => {
				if (res.result) {
					this.tipsHandle(res.msg, 'success', 1500)
					this.findall()
				} else {
					this.tipsHandle(res.msg, 'error', 1500)
				}
			})
		},
		settingStatus (val) {
			this.checkedStatus.forEach(item => {
				this.status.forEach(item2 => {
					if (item2.name === item) {
						this.mapOpj[item2.id] = 1
					}
				})
			})
			if (this.mapOpj[1]) {
				delete this.mapOpj[1]
			}
			let params = this.mapOpj
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/systemcenter/matchorganinfo/setCanpaystatus`,
				data: params
			}).then(res => {
				if (res.result) {
					this.mapOpj = {}
					this.tipsHandle(res.msg, 'success', 1500)
					this.findall()
				} else {
					this.tipsHandle(res.msg, 'error', 1500)
				}
			})
		},
		settingStatusBranch () {
			const prevCanPayStatuses = (this.checkedStatusBranch1 || []).join(',')
			this.mapOpj = {}
			this.checkedStatusBranch1.forEach(item => {
				this.statusBranch1.forEach(item2 => {
					if (item2.name === item) {
						this.mapOpj[item2.id] = 1
					}
				})
			})
			if (this.mapOpj[1]) {
				delete this.mapOpj[1]
			}
			const params = {
				canPayStatus: this.mapOpj,
				shopIds: this.getBranchShopIds(true)
			}
			if (!params.shopIds) {
				this.tipsHandle('请选择店铺', 'error', 1500)
				this.mapOpj = {}
				this.findall()
				return
			}
			const nextNames = []
			this.statusBranch1.forEach(item => {
				if (this.mapOpj[item.id]) {
					nextNames.push(item.name)
				}
			})
			const nextCanPayStatuses = Array.from(new Set(nextNames)).join(',')
			this.ruleForm.shopCanPayStatuses = nextCanPayStatuses
			const logger = this.$fxLogger.createInfo('system.order-setting.update', this.createLoggerParams())
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIV}/shop/systemcenter/matchorganinfo/setShopCanPayStatus`,
				data: params,
				logger
			}).then(res => {
				if (res.result) {
					this.mapOpj = {}
					this.tipsHandle(res.msg, 'success', 1500)
					this.findall()
				} else {
					this.ruleForm.shopCanPayStatuses = prevCanPayStatuses
					this.tipsHandle(res.msg, 'error', 1500)
				}
			}).catch(err => {
				this.ruleForm.shopCanPayStatuses = prevCanPayStatuses
				this.tipsHandle((err && err.msg) || '设置失败', 'error', 1500)
			})
		},
		buildOrderFlowItemsForPaytype (paytypeStr) {
			const clone = (arr) => this.$fxUtils.deepClone(arr)
			let list = []
			if (paytypeStr === '1') {
				list = clone(this.items1)
			} else if (this.needAuditingFlag) {
				list = clone(this.items2)
			} else {
				list = clone(this.items3)
			}
			if (this.form.difference === '1') {
				list.forEach(item => {
					if (item.name === '待接单') {
						item.active = true
					}
				})
			} else {
				list.forEach(item => {
					if (item.name === '待接单') {
						item.active = false
					}
				})
			}
			if (this.form.financialAuditFlag === '1') {
				list.forEach(item => {
					if (item.name === '财务审核') {
						item.active = true
					}
				})
			} else {
				list.forEach(item => {
					if (item.name === '财务审核') {
						item.active = false
					}
				})
			}
			if (!this.matchbillcenterflag) {
				const idx = list.findIndex(item => item.name === '备货中')
				if (idx > -1) {
					list.splice(idx, 1)
				}
			} else {
				const idx = list.findIndex(item => item.name === '待发货')
				if (idx > -1) {
					list.splice(idx, 1)
				}
			}
			return list
		},
		refreshBranchFlowItems () {
			this.itemsBranch0 = this.buildOrderFlowItemsForPaytype('0')
			this.itemsBranch1 = this.buildOrderFlowItemsForPaytype('1')
			this.applyBranchWaitingOrderActive(this.itemsBranch0, false)
			this.applyBranchWaitingOrderActive(this.itemsBranch1, true)
			this.applyBranchFinancialAuditActive(this.itemsBranch0, false)
			this.applyBranchFinancialAuditActive(this.itemsBranch1, true)
			this.statusBranch1 = this.$fxUtils.deepClone(this.matchbillcenterflag ? this.status2 : this.status1)
			this.checkedStatusBranch1 = this.resolveBranchCheckedStatus()
		},
		resolveBranchCheckedStatus () {
			const branchStatus = this.matchbillcenterflag ? this.status2 : this.status1
			const rawStatuses = this.shopPayment && Array.isArray(this.shopPayment.canPayStatuses)
				? this.shopPayment.canPayStatuses
				: []
			if (!rawStatuses.length) {
				return this.$fxUtils.deepClone(this.checkedStatus)
			}
			const statusIdSet = new Set(rawStatuses.map(item => String(item)))
			const names = []
			branchStatus.forEach(item => {
				if (statusIdSet.has(String(item.id))) {
					names.push(item.name)
				}
			})
			return Array.from(new Set(names))
		},
		resolveShopWaitingOrderEnabled (canPayLater) {
			const listByPayType = canPayLater
				? this.shopPayment.canPayLaterShopList
				: this.shopPayment.cannotPayLaterShopList
			if (!Array.isArray(listByPayType) || listByPayType.length === 0) {
				return true
			}
			const first = listByPayType[0] || {}
			const raw = first.needWaitingOrder !== undefined && first.needWaitingOrder !== null
				? first.needWaitingOrder
				: (first.needwaitingorder !== undefined && first.needwaitingorder !== null
					? first.needwaitingorder
					: (first.waitingOrder !== undefined && first.waitingOrder !== null
						? first.waitingOrder
						: (first.shopWaitingOrder !== undefined && first.shopWaitingOrder !== null
							? first.shopWaitingOrder
							: (first.shopwaitingorder !== undefined && first.shopwaitingorder !== null
								? first.shopwaitingorder
								: first.waitingorder))))
			if (raw === undefined || raw === null || raw === '') {
				return true
			}
			if (typeof raw === 'boolean') {
				return raw
			}
			return Number(raw) === 1
		},
		applyBranchWaitingOrderActive (list, canPayLater) {
			const waitingOrderEnabled = this.resolveShopWaitingOrderEnabled(canPayLater)
			list.forEach(item => {
				if (item.name === '待接单') {
					item.active = waitingOrderEnabled
				}
			})
		},
		resolveShopFinancialAuditingEnabled (canPayLater) {
			const listByPayType = canPayLater
				? this.shopPayment.canPayLaterShopList
				: this.shopPayment.cannotPayLaterShopList
			if (!Array.isArray(listByPayType) || listByPayType.length === 0) {
				return true
			}
			const first = listByPayType[0] || {}
			const raw = first.needFinancialAuditingFlag !== undefined && first.needFinancialAuditingFlag !== null
				? first.needFinancialAuditingFlag
				: (first.needfinancialauditingflag !== undefined && first.needfinancialauditingflag !== null
					? first.needfinancialauditingflag
					: first.financialAuditFlag)
			if (raw === undefined || raw === null || raw === '') {
				return true
			}
			if (typeof raw === 'boolean') {
				return raw
			}
			return Number(raw) === 1
		},
		applyBranchFinancialAuditActive (list, canPayLater) {
			const financialAuditingEnabled = this.resolveShopFinancialAuditingEnabled(canPayLater)
			list.forEach(item => {
				if (item.name === '财务审核') {
					item.active = financialAuditingEnabled
				}
			})
		},
		paymentMethodSettingChange (val) {
			const next = Number(val) === 1 ? 1 : 0
			let formData = new FormData()
			formData.append('paymentMethodSetting', next)
			this.ruleForm.paymentMethodSetting = next
			const logger = this.$fxLogger.createInfo('system.order-setting.update', this.createLoggerParams())
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/systemcenter/matchorganinfo/setPaymentMethodSetting`,
				data: formData,
				logger
			}).then(res => {
				if (res.result) {
					this.tipsHandle(res.msg, 'success', 1500)
					this.findall()
				} else {
					this.tipsHandle(res.msg, 'error', 1500)
					this.findall()
				}
			}).catch(err => {
				this.$message.error(err.msg)
				this.findall()
			})
		},
		openShopPaymentDialog (canPayLater) {
			this.shopPaymentTransferCanPayLater = canPayLater
			this.shopPaymentChooseShop = []
			const canPayLaterNum = canPayLater ? 1 : 0
			const listByPayType = canPayLater
				? this.shopPayment.canPayLaterShopList
				: this.shopPayment.cannotPayLaterShopList
			const fallbackSelectedKeys = Array.isArray(listByPayType)
				? listByPayType.map(item => {
					if (item && typeof item === 'object') {
						if (item.shopId !== undefined && item.shopId !== null) {
							return item.shopId
						}
						if (item.shopid !== undefined && item.shopid !== null) {
							return item.shopid
						}
						return item.id
					}
					return item
				}).filter(id => id !== undefined && id !== null && id !== '')
				: []
			let formData = new FormData()
			formData.append('canpaylater', canPayLaterNum)
			const logger = this.$fxLogger.createInfo('system.order-setting.update', this.createLoggerParams())
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/systemcenter/matchorganinfo/getShopPaymentSetting`,
				data: formData,
				logger
			}).then(res => {
				if (!res.result) {
					this.$message.error(res.msg || '加载失败')
					return
				}
				const raw = res.data
				let rows = []
				if (Array.isArray(raw)) {
					rows = raw
				} else if (raw && Array.isArray(raw.shopList)) {
					rows = raw.shopList
				} else if (raw && Array.isArray(raw.shops)) {
					rows = raw.shops
				} else if (raw && Array.isArray(raw.list)) {
					rows = raw.list
				} else if (raw && raw.data && Array.isArray(raw.data)) {
					rows = raw.data
				}
				const selectedKeys = []
				rows.forEach((r, idx) => {
					const key = (r.shopId !== undefined && r.shopId !== null)
						? r.shopId
						: (r.shopid !== undefined && r.shopid !== null
							? r.shopid
							: (r.id !== undefined && r.id !== null ? r.id : 'k-' + idx))
					const inRight = r.selected === true || r.chosen === true || r.checked === true || r.inRight === true || r.assignFlag === 1 || r.isSelected === true
					if (inRight) {
						selectedKeys.push(key)
					}
				})
				this.shopPaymentChooseShop = selectedKeys.length ? selectedKeys : fallbackSelectedKeys
				this.shopPaymentDialogVisible = true
			}).catch(err => {
				this.$message.error(err.msg || '加载失败')
			})
		},
		resetShopPaymentDialog () {
			this.shopPaymentChooseShop = []
			this.shopPaymentSaveLoading = false
		},
		onShopPaymentBindSave (data) {
			const ids = (data.chooseData || []).map(id => String(id)).join(',')
			const canPayLaterNum = this.shopPaymentTransferCanPayLater ? 1 : 0
			let formData = new FormData()
			formData.append('shopIds', ids)
			formData.append('canpaylater', canPayLaterNum)
			this.shopPaymentSaveLoading = true
			let loggerParams = this.createLoggerParams()
			if (!this.shopPaymentTransferCanPayLater) {
				const prevShopText = this.getBranchShopText(false)
				const curShopText = data.shopText || ''
				this.ruleForm.shopSelectBeforePay = curShopText
				loggerParams.pre = Object.assign({}, loggerParams.pre, {
					shopSelectBeforePay: prevShopText
				})
				loggerParams.cur = Object.assign({}, loggerParams.cur, {
					shopSelectBeforePay: curShopText
				})
			} else {
				const prevShopText = this.getBranchShopText(true)
				const curShopText = data.shopText || ''
				this.ruleForm.shopSelectAfterPay = curShopText
				loggerParams.pre = Object.assign({}, loggerParams.pre, {
					shopSelectAfterPay: prevShopText
				})
				loggerParams.cur = Object.assign({}, loggerParams.cur, {
					shopSelectAfterPay: curShopText
				})
			}
			const logger = this.$fxLogger.createInfo('system.order-setting.update', loggerParams)
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/systemcenter/matchorganinfo/setShopCanPayLater`,
				data: formData,
				logger
			}).then(res => {
				this.shopPaymentSaveLoading = false
				if (res.result) {
					this.tipsHandle(res.msg, 'success', 1500)
					this.shopPaymentDialogVisible = false
					this.findall()
				} else {
					this.tipsHandle(res.msg, 'error', 1500)
				}
			}).catch(err => {
				this.shopPaymentSaveLoading = false
				this.$message.error(err.msg || '保存失败')
			})
		},
		orderStatusChangeBranch (val, branchKey) {
			if (!this.AuthorityList['06_0001_0002_00']) {
				this.tipsHandle('没有权限！', 'error', 1500)
				return false
			}
			if (val.id === 1) {
				if (!this.needAuditingFlag) {
					const prevActive = val.active
					val.active = !val.active
					const shopWaitingOrder = val.active ? 1 : 0
					const canPayLater = branchKey === '1'
					this.setShopWaitingOrderByBranch(canPayLater, shopWaitingOrder, prevActive, val)
				}
			} else if (val.id === 6) {
				const prevActive = val.active
				val.active = !val.active
				const canPayLater = branchKey === '1'
				this.setShopNeedFinancialAuditingFlagByBranch(canPayLater, val.active, prevActive, val)
			}
		},
		getBranchShopIds (canPayLater) {
			const listByPayType = canPayLater
				? this.shopPayment.canPayLaterShopList
				: this.shopPayment.cannotPayLaterShopList
			if (!Array.isArray(listByPayType)) {
				return ''
			}
			return listByPayType.map(item => {
				if (item && typeof item === 'object') {
					if (item.shopId !== undefined && item.shopId !== null) {
						return item.shopId
					}
					if (item.shopid !== undefined && item.shopid !== null) {
						return item.shopid
					}
					return item.id
				}
				return item
			}).filter(id => id !== undefined && id !== null && id !== '').join(',')
		},
		getBranchShopText (canPayLater) {
			const listByPayType = canPayLater
				? this.shopPayment.canPayLaterShopList
				: this.shopPayment.cannotPayLaterShopList
			if (!Array.isArray(listByPayType)) {
				return ''
			}
			return listByPayType.map(item => {
				if (item && typeof item === 'object') {
					return item.shopName || item.name || item.shopname || ''
				}
				return ''
			}).filter(name => !!name).join('，')
		},
		setShopWaitingOrderByBranch (canPayLater, shopWaitingOrder, prevActive, val) {
			const shopIds = this.getBranchShopIds(canPayLater)
			if (!shopIds) {
				this.tipsHandle('请选择店铺', 'error', 1500)
				val.active = !val.active
				return
			}
			let formData = new FormData()
			formData.append('shopIds', shopIds)
			formData.append('needWaitingOrder', shopWaitingOrder)
			const prevWaitingOrder = this.ruleForm.waitingOrder
			this.ruleForm.waitingOrder = String(shopWaitingOrder)
			const loggerParams = this.createLoggerParams()
			loggerParams.pre = Object.assign({}, loggerParams.pre, {
				waitingOrder: prevActive ? '1' : '0'
			})
			loggerParams.cur = Object.assign({}, loggerParams.cur, {
				waitingOrder: String(shopWaitingOrder)
			})
			if (canPayLater) {
				loggerParams.pre = Object.assign({}, loggerParams.pre, {
					shopWaitingOrderStatus: prevActive ? '1' : '0',
					waitingOrder: String(shopWaitingOrder)
				})
				loggerParams.cur = Object.assign({}, loggerParams.cur, {
					shopWaitingOrderStatus: String(shopWaitingOrder)
				})
			} else {
				loggerParams.pre = Object.assign({}, loggerParams.pre, {
					shopWaitingOrderStatusBeforePay: prevActive ? '1' : '0',
					waitingOrder: String(shopWaitingOrder)
				})
				loggerParams.cur = Object.assign({}, loggerParams.cur, {
					shopWaitingOrderStatusBeforePay: String(shopWaitingOrder)
				})
			}
			const logger = this.$fxLogger.createInfo('system.order-setting.update', loggerParams)
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIV}/shop/systemcenter/setShopWaitingOrder`,
				data: formData,
				logger
			}).then(res => {
				if (res.result || res.res) {
					this.tipsHandle(res.msg || '设置成功', 'success', 1500)
					this.findall()
				} else {
					this.ruleForm.waitingOrder = prevWaitingOrder
					this.tipsHandle(res.msg || '设置失败', 'error', 1500)
					val.active = !val.active
				}
			}).catch(err => {
				this.ruleForm.waitingOrder = prevWaitingOrder
				this.tipsHandle(err.msg || '设置失败', 'error', 1500)
				val.active = !val.active
			})
		},
		setShopNeedFinancialAuditingFlagByBranch (canPayLater, needFinancialAuditingFlag, prevActive, val) {
			const shopIds = this.getBranchShopIds(canPayLater)
			if (!shopIds) {
				this.tipsHandle('请选择店铺', 'error', 1500)
				val.active = !val.active
				return
			}
			const needFinancialAuditingFlagNum = needFinancialAuditingFlag ? 1 : 0
			let formData = new FormData()
			formData.append('shopIds', shopIds)
			formData.append('needFinancialAuditingFlag', needFinancialAuditingFlagNum)
			const prevFinancialAuditFlag = this.ruleForm.financialAuditFlag
			this.ruleForm.financialAuditFlag = String(needFinancialAuditingFlagNum)
			const loggerParams = this.createLoggerParams()
			loggerParams.pre = Object.assign({}, loggerParams.pre, {
				financialAuditFlag: prevActive ? '1' : '0'
			})
			loggerParams.cur = Object.assign({}, loggerParams.cur, {
				financialAuditFlag: String(needFinancialAuditingFlagNum)
			})
			if (canPayLater) {
				loggerParams.pre = Object.assign({}, loggerParams.pre, {
					shopFinancialAuditStatus: prevActive ? '1' : '0',
					financialAuditFlag: String(needFinancialAuditingFlagNum)
				})
				loggerParams.cur = Object.assign({}, loggerParams.cur, {
					shopFinancialAuditStatus: String(needFinancialAuditingFlagNum)
				})
			} else {
				loggerParams.pre = Object.assign({}, loggerParams.pre, {
					shopFinancialAuditStatusBeforePay: prevActive ? '1' : '0',
					financialAuditFlag: String(needFinancialAuditingFlagNum)
				})
				loggerParams.cur = Object.assign({}, loggerParams.cur, {
					shopFinancialAuditStatusBeforePay: String(needFinancialAuditingFlagNum)
				})
			}
			const logger = this.$fxLogger.createInfo('system.order-setting.update', loggerParams)
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIV}/shop/systemcenter/setShopNeedFinancialAuditingFlag`,
				data: formData,
				logger
			}).then(res => {
				if (res.result || res.res) {
					this.tipsHandle(res.msg || '设置成功', 'success', 1500)
					this.findall()
				} else {
					this.ruleForm.financialAuditFlag = prevFinancialAuditFlag
					this.tipsHandle(res.msg || '设置失败', 'error', 1500)
					val.active = !val.active
				}
			}).catch(err => {
				this.ruleForm.financialAuditFlag = prevFinancialAuditFlag
				this.tipsHandle(err.msg || '设置失败', 'error', 1500)
				val.active = !val.active
			})
		},
		syncBranchItemActiveByName (name, active, skipBranchKey) {
			const apply = (list) => {
				if (!list || !list.length) {
					return
				}
				list.forEach(it => {
					if (it.name === name) {
						it.active = active
					}
				})
			}
			if (skipBranchKey !== '0') {
				apply(this.itemsBranch0)
			}
			if (skipBranchKey !== '1') {
				apply(this.itemsBranch1)
			}
			apply(this.items)
		},
		orderStatusChange (val) {
			if (!this.AuthorityList['06_0001_0002_00']) {
				this.tipsHandle('没有权限！', 'error', 1500)
				return false
			}
			if (val.id === 1) {
				if (!this.needAuditingFlag) {
					val.active = !val.active
					if (val.active) {
						this.form.difference = '1'
					} else {
						this.form.difference = '0'
					}
					this.settingChange()
				}
			} else if (val.id === 6) {
				val.active = !val.active
				if (val.active) {
					this.form.financialAuditFlag = '1'
				} else {
					this.form.financialAuditFlag = '0'
				}
				this.financialAuditSetting(this.form.financialAuditFlag)
			}
		}
	}
}
</script>

<style lang="stylus" scoped>
.order-setting-body {
	display: flex;
	flex-direction: column;
	overflow-y :auto;
	padding-left: 30px;
	.order-setting-container {
		display flex
		.el-collapse {
			.paytype-box {
				display: flex
				flex-flow: column
				.payment-branch-box {
					margin-top: 16px
					padding-top: 16px
					border-top: 1px dashed #ddd
				}
				.payment-branch-box--second {
					margin-top: 20px
				}
				.payment-branch-head {
					align-items: center
					.payment-branch-title {
						font-size: 14px
						font-weight: 600
						margin-right: 12px
						color: #303133
					}
				}
				.paytype-item {
					display: flex
					align-items: center
					margin-top: 20px
					span {
						font-size: 12px
						color: #595959
					}
					.item-box {
						position: relative
						cursor: pointer
						display: inline-block;
						width: 82px
						height: 32px
						line-height: 32px
						border-radius: 4px
						text-align: center
						font-size: 12px
						font-weight: 400
					}
					.active {
						background: #FFFFFF
						border: 1px solid var(--fx-primary-color)
						color: var(--fx-primary-color)
					}
					.unactive {
						background: #E5E5E5
						border: 1px solid #CCCCCC
						color: #999999
					}
					.red {
						color: #FF3333
					}
				}
			}
			.select-box{
				width:250px
			}
			.long-span-box{
				text-align :right;
				display: inline-block;
				width :200px
				margin-bottom: 20px;
			}
			.span-box{
				text-align :right;
				display: inline-block;
				width :180px
				&.hide-title {
					position: relative
					.hide-span {
						position: absolute
						top: 28px
						left: 62px
						color: #fff
						opacity 0
						cursor: default;
					}
				}
			}
			.auto-receive-box {
				display: inline-block;
			}
			width: 100%;
			/deep/.el-collapse-item__content {
				text-align left
				padding-left 50px;
				padding-bottom 10px;
			}
			/deep/.el-collapse-item__header {
				font-size 16px
				font-weight 700px
			}
			/deep/.el-collapse-item__arrow {
				margin-left: 20px
			}
			.form-container {
				width: 100%
				.select-container {
					width: 120px
				}
			}
			.refundForm-form {
				width: 260px
				margin-top: 10px
				.select-container {
					width: 85px
				}
			}
			p {
				line-height: 28px
				color: #FF3333
				padding-left: 10px
				font-size: 14px
			}
			.order-title {
				margin-bottom 20px;
			}
			.el-radio-group {
				display flex
				flex-direction row
				flex-wrap nowrap
				align-items center
				.el-radio {
					margin-bottom 0
					margin-right 20px
					white-space nowrap
					&:last-child {
						margin-right 0
					}
				}
			}
		}
	}
	.tip-icon {
		display: inline-block;
		cursor: pointer;
		margin: 0 10px 0 10px;
	}
}
</style>
<style lang="stylus">
.el-tooltip__popper.is-dark.tip-class {
	width: 320px
}
</style>
